/**
 * Base LiveScoreAdapter class
 *
 * Each adapter should extends this class & implement the following methods:
 *
 *    connect(array connectionParams);
 *    subscribe({ sportName, eventId });
 *    unsubscribe({ sportName, eventId });
 *    disconnect();
 *
 * Each adapter should also call fire() method on the following events:
 *
 *    connect - connection established
 *    connect_error - connect error or permanent connection lost
 *    connect_warning - temporary connection problem (recovered internally by the adapter)
 *    reconnect - connection recovered (after connect_warning)
 *    disconnect - connection closed
 *    data - received data for subscribed topic
 */
class LiveScoreAdapter {
  constructor() {
    this.subscribedEvents = [];
    this.listeners = {};
    this.addEventListener = this.on;
    this.removeEventListener = this.off;
  }

  static formatTime(seconds) {
    let mm = Math.floor(seconds / 60);
    let ss = seconds % 60;

    if (mm < 10) mm = `0${mm}`;
    if (ss < 10) ss = `0${ss}`;

    return `${mm}:${ss}`;
  }

  static parseTime(time) {
    const [minutes, seconds] = time.split(':', 2);

    return (Number(minutes) * 60) + Number(seconds);
  }

  static formatPeriod(period) {
    return period.replace(/_/g, ' ').toLowerCase();
  }

  on(type, fn) {
    if (!this.listeners[type]) {
      this.listeners[type] = [];
    }
    this.listeners[type].push(fn);
  }

  off(type, fn) {
    if (!this.listeners[type]) {
      return;
    }
    this.listeners[type] = this.listeners[type].filter(f => f !== fn);
    if (!this.listeners[type].length) {
      this.listeners[type] = undefined;
    }
  }

  fire(type, data) {
    if (!this.listeners[type]) {
      return;
    }
    this.listeners[type].forEach(fn => fn(data));
  }

  updateSubscribtions(events) {
    const eventEquals = e1 => e2 => e1.sport === e2.sport && e1.eventId === e2.eventId;
    const eventsToSubscribe = events.filter(
      event => this.subscribedEvents.findIndex(eventEquals(event)) === -1
    );
    const eventsToUnsubscribe = this.subscribedEvents.filter(
      event => events.findIndex(eventEquals(event)) === -1
    );
    eventsToSubscribe.forEach(event => this.subscribe(event));
    eventsToUnsubscribe.forEach(event => this.unsubscribe(event));
  }
}

export default LiveScoreAdapter;
